export enum EAdminRoutesNames {
  // base
  AdminNotFoundPage = 'AdminNotFoundPage',
  AdminForbiddenPage = 'AdminForbiddenPage',

  AdminNotificationTypesPage = 'AdminNotificationTypesPage',
  AdminNotificationsPage = 'AdminNotificationsPage',
  AdminRecipientsPage = 'AdminRecipientsPage',
  AdminSubscriptionsPage = 'AdminSubscriptionsPage',
  AdminNotificationRolesPage = 'AdminNotificationRolesPage',
}
